<!-- eslint-disable vue/no-v-html -->
<template>
    <div class="page-body">
      <div class="container-fluid">
          <Loader :loading="isLoading" />
          <loader-component v-if="isLoading" :loading="isLoading" />
          <div class="card">
            <div class="controls-wrapper">
              <!-- Mostrar: dropdown para seleccionar usuarios por página -->
              <div class="d-flex align-items-center mb-3">
                <span class="me-2">Mostrar:</span>
                  <select 
                    v-model="itemsPerPage" 
                    @change="resetPagination"
                    class="form-select w-auto"
                  >
                    <option :value="20">20</option>
                    <option :value="50">50</option>
                    <option :value="100">100</option>
                  </select>
                  <span class="ms-2">registros</span>
                </div>
                <div class="filters-container d-flex justify-content-between align-items-center">
                  <!-- Botón a la izquierda -->
                  <button @click="goToCompanyForm(advisorId)" class="custom-create-btn">
                    <span class="custom-create-btn-text">Crear Propiedad</span>
                  </button>
                  <!-- Buscador -->
                  <!-- Contenedor de filtros a la derecha -->
                  <div class="filters-group d-flex align-items-center">
                    <!-- Selector de tipo de inmueble -->
                    <select 
                      v-model="propertyTypeFilter"
                      class="px-4 py-[9px] bg-white rounded-md text-neutral-500 text-sm font-light font-['Poppins'] leading-normal border border-gray-200"
                    >
                      <option value="">Todos los tipos</option>
                      <option value="Casa">Casa</option>
                      <option value="Departamento">Departamento</option>
                      <option value="Terreno">Terreno</option>
                      <option value="Local">Local</option>
                      <option value="Oficina">Oficina</option>
                    </select>

                    <!-- Selector de estatus -->
                    <select 
                      v-model="statusFilter"
                      class="px-4 py-[9px] bg-white rounded-md text-neutral-500 text-sm font-light font-['Poppins'] leading-normal border border-gray-200"
                    >
                      <option value="">Todos los estatus</option>
                      <option value="Activo">Activo</option>
                      <option value="Desactivado">Desactivado</option>
                      <option value="Sin estatus">Sin estatus</option>
                    </select>

                    <!-- Input del buscador -->
                    <input
                      type="text"
                      class="w-64 px-4 py-[9px] bg-white rounded-md text-neutral-500 text-sm font-light font-['Poppins'] leading-normal border border-gray-200"
                      placeholder="Buscar"
                      v-model="searchQuery"
                    />
                  </div>
                </div>  
              </div>
              <div class="row my-3">
                <div class="w-full ">
                </div>
              </div>
              <div class="overflow-x-auto">
                <table class="min-w-full bg-white border border-gray-200 rounded-lg">
                  <thead class="bg-gray-100 text-gray-600 uppercase text-sm leading-normal">
                    <tr>
                      <th class="py-3 px-6 text-style-custom text-left hidden md:table-cell">ID</th>
                      <th class="py-3 px-6 text-style-custom text-left">Nombre</th>
                      <th class="py-3 px-6 text-style-custom text-left hidden md:table-cell" >Tipo de Inmueble</th>
                      <th class="py-3 px-6 text-style-custom text-left hidden md:table-cell" >Movimiento</th>
                      <th class="py-3 px-6 text-style-custom text-left hidden md:table-cell" >Precio Venta</th>
                      <th class="py-3 px-6 text-style-custom text-left hidden md:table-cell" >Precio Renta</th>
                      <th class="py-3 px-6 text-style-custom text-left hidden md:table-cell" >Estado</th>
                      <th class="py-3 px-6 text-style-custom text-left hidden md:table-cell" >Municipio</th>
                      <th class="py-3 px-6 text-style-custom text-left" >Estatus</th>
                      <th class="py-3 px-6 text-style-custom text-left hidden md:table-cell">Acciones</th>
                    </tr>
                  </thead>
                  <tbody class="text-gray-600 text-sm font-light">
                    <tr
                      v-for="(properties, index) in filteredCargos" :key="index" class="border-b border-gray-200 hover:bg-gray-100"
                      :class="{'bg-white': index % 2 === 0, // Filas pares (índice empieza desde 0)
                        'bg-gray-100': index % 2 !== 0    // Filas impares
                      }"
                    >
                      <td class="py-4 px-6 custom-width-text whitespace-nowrap hidden md:table-cell" :class="{'opacity-50':  properties.translatedStatus === 'Desactivado'}">{{ properties.id }}</td>
                      <td class="py-4 px-6 custom-width-text whitespace-nowrap" :class="{'opacity-50':  properties.translatedStatus === 'Desactivado'}">{{ truncatedDescription (properties.property_name) }}</td>
                      <td class="py-4 px-6 custom-width-text whitespace-nowrap hidden md:table-cell" :class="{'opacity-50':  properties.translatedStatus === 'Desactivado'}">{{ properties.type_property }}</td>
                      <td class="py-4 px-6 custom-width-text whitespace-nowrap hidden md:table-cell" :class="{'opacity-50':  properties.translatedStatus === 'Desactivado'}">{{ properties.type_movement}}</td>
                      <td class="py-4 px-6 custom-width-text whitespace-nowrap hidden md:table-cell" :class="{'opacity-50':  properties.translatedStatus === 'Desactivado'}">{{ properties.property_value}}</td>
                      <td class="py-4 px-6 custom-width-text whitespace-nowrap hidden md:table-cell" :class="{'opacity-50':  properties.translatedStatus === 'Desactivado'}">{{ properties.rent_value}}</td>
                      <td class="py-4 px-6 custom-width-text whitespace-nowrap hidden md:table-cell" :class="{'opacity-50':  properties.translatedStatus === 'Desactivado'}">{{ properties.state }}</td>
                      <td class="py-4 px-6 custom-width-text whitespace-nowrap hidden md:table-cell" :class="{'opacity-50':  properties.translatedStatus === 'Desactivado'}">{{ properties.municipality }}</td>
                      <td class="py-4 px-6 custom-width-text whitespace-nowrap">
                        <span class="status-indicator" :class="{ 'bg-yellow': properties.status === 'Bloqueado','bg-red': properties.status === 'Desactivado', 'bg-green': properties.status !== 'Bloqueado' && properties.status !== 'Desactivado'}">
                          {{ properties.translatedStatus || 'Sin estatus' }}
                        </span>
                      </td>
                      <td class="py-4 px-6 custom-width-text whitespace-nowrap">
                        <div class="relative" ref="el => menuContainers.push(el)">
                          <svg 
                            @click.stop="toggleMenu(properties.id)" 
                            xmlns="http://www.w3.org/2000/svg" 
                            width="17" 
                            height="4" 
                            viewBox="0 0 17 4" 
                            fill="none" 
                            class="cursor-pointer">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M1.96152 0C3.04429 0 3.92304 0.896031 3.92304 2C3.92304 3.10397 3.04425 4 1.96152 4C0.878748 4 0 3.10397 0 2C0 0.896031 0.878792 0 1.96152 0ZM8.49978 0C9.58255 0 10.4613 0.896031 10.4613 2C10.4613 3.10397 9.58251 4 8.49978 4C7.41705 4 6.53826 3.10397 6.53826 2C6.53826 0.896031 7.41705 0 8.49978 0ZM15.0385 0C16.1213 0 17 0.896031 17 2C17 3.10397 16.1212 4 15.0385 4C13.9557 4 13.077 3.10397 13.077 2C13.077 0.896031 13.9557 0 15.0385 0Z" fill="#FF4265"/>
                          </svg>
                          <div v-show="menuVisible === properties.id" class="absolute right-0 bg-white bord shadow-lg mt-1 w-48 z-10">
                            <ul class="py-1">
                              <li class="px-4 py-2 hover:bg-gray-100 cursor-pointer" @click="verPerfil(properties.slug_url)">Ver Perfil</li>
                              <li class="px-4 py-2 hover:bg-gray-100 cursor-pointer" @click="editCargo(properties.id)">Editar</li>
                              <li class="px-4 py-2 hover:bg-gray-100 cursor-pointer text-red-500" @click="deleteCargo(company.id)">Desactivar</li>
                            </ul>
                          </div>
                        </div>
                      </td>
                      </tr>
                    </tbody>
                  </table>
                    <DeleteModal
                      v-if="showModal"
                      :visible="showModal"
                      @close="showModal = false"
                      @confirm="confirmDelete"
                    />
                  </div>
                  <div class="flex justify-between items-center w-full">
                    <div class="w-[278px] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal">
                      Mostrando {{ currentPage }} de {{ totalPages }}
                    </div>
                    <!-- Pagination Controls -->
                    <div style="display: flex; justify-content: flex-end; align-items: center; padding: 8px 12px;">
                      <button 
                        @click="changePage(currentPage - 1)" 
                        :disabled="currentPage === 1"
                        class="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
                        :style="{padding: '8px 12px', border: '1px solid var(--Primary-Primary,  #FFD8DF)', background: 'var(--Primary-Primary, #FFF)', color: '#FF4265', opacity: page === 1 ? '0.5' : '1',cursor: page === 1 ? 'not-allowed' : 'pointer' }"
                      >
                        &lt;
                      </button>
                        
                      <!-- Números de página -->
                      <div style="display: flex; gap: 0; align-items: center;">
                        <button
                          v-for="pageNumber in totalPages" 
                          :key="pageNumber" @click="changePage(pageNumber)" 
                          :style="{padding: '8px 12px',border: '1px solid var(--Primary-Primary,  #FFD8DF)',background: pageNumber === page ? '#FF4265' : 'var(--Primary-Primary, #FFF)',color: pageNumber === page ? '#FFF' : '#FF4265',fontWeight: pageNumber === page ? 'bold' : 'normal',
                          cursor: 'pointer'
                          }"
                        >
                          {{ pageNumber }}
                        </button>
                      </div>
                        
                      <button 
                        @click="changePage(currentPage + 1)" 
                        :disabled="currentPage === totalPages"
                        class="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
                        :style="{padding: '8px 12px',border: '1px solid var(--Primary-Primary,  #FFD8DF)',background: 'var(--Primary-Primary, #FFF)',color: '#FF4265',opacity: page >= totalPages ? '0.5' : '1',cursor: page >= totalPages ? 'not-allowed' : 'pointer'
                        }"
                      >
                        &gt;
                      </button>
                    </div>
                  </div>
                  <head>
                    <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap" rel="stylesheet">
                  </head>
                </div>
          </div>        
        </div>

</template>
  
  
  <script setup>
  import { ref, onMounted, onBeforeUnmount} from 'vue';
  import axios from 'axios';
  import { computed } from "vue";
  import { useStore } from 'vuex';
  import { useRoute } from "vue-router";
  import 'vue-toastification/dist/index.css';
  //import Loader from '@/components/loaderComponent.vue';
  import DeleteModal from '@/components/company/Modal/DeleteCompanyModal.vue';
  import { useRouter } from 'vue-router';
  
  // Referencias y estado
  const isLoading = ref(true); // Inicializamos isLoading
  //const page = ref(1); // Página actual
  const searchQuery = ref("");  // Para almacenar el término de búsqueda
  const menuVisible = ref(null);
  const store = useStore();
  let session = computed(() => store.getters.getUserSession);
  const route = useRoute();
  let userId = computed(() => route.params.id);
  let advisorId = computed(() => route.params.id);
  const properties = ref([]);
  const company = ref([]); // Aquí guardaremos todos los roles
  //const showDeleteModal = ref(false); // Controla la visibilidad del modal
  const showModal = ref(false); // Controla la visibilidad del modal
  const selectedCargoId = ref(null);
  const router = useRouter();
  const currentPage = ref(1);
  const itemsPerPage = ref(10); // Number of items to show per page
  const menuContainers = ref([]); 
  const statusFilter = ref(''); // Nuevo ref para el filtro de estatus
  const   propertyTypeFilter = ref('');
  // Métodos
  async function get_propierties() {
        try {
            let url_cnn = `${process.env.VUE_APP_API_BASE_URL}/property/${userId.value}`;
            var options = {
            headers: {
                "Content-Type": "application/json", // Es importante establecer el tipo de contenido para el envío de archivos
                Authorization: `Bearer ${session.value.token_api}`, // Reemplaza tuTokenBearer con tu token real
            },
            };

            const response = await axios.get(url_cnn, options);
            if (response.status === 200 && response.data?.properties) {
              // Verificamos la respuesta con un console.log
              console.log(response.data.properties);

              // Mapear propiedades y traducir status
              properties.value = response.data.properties.map(property => {
                  console.log("Estado original:", property.status);  // Verifica el estado original
                  const translatedStatus = translateStatus(property.status);
                  console.log("Estado traducido:", translatedStatus); // Verifica la traducción
                  return {
                      ...property,
                      translatedStatus: translatedStatus
                  };
              });
            }

        } catch (error) {
    
            if (error.response.status === 401) {
            store.dispatch("clearUserSession");
            router.push({ name: "login" });
            
            }
        }
        finally {
                isLoading.value = false;
        }
    }

    const deleteCargo = (company_id) => {
    selectedCargoId.value = company_id; // Almacena el ID del usuario
    showModal.value = true
  };

  //const profileCompany = (id) => {
  //    console.log("ID del rol:", id); // Imprime el ID en la consola
  //    router.push({ name: 'company-profile', params: { id } }); // Asegúrate de que el nombre coincida con el de la ruta
  //};
  const translateStatus = (status) => {
    // Verifica si el estado es null o undefined
    if (status === null || status === undefined) {
      return 'Sin estatus';
    }

    const statusTranslations = {
      available: 'Activo',
      disabled: 'Desactivado',
      // Agrega más traducciones según sea necesario
    };

    return statusTranslations[status] || status; // Devuelve el estado original si no se encuentra traducción
  };
  const truncatedDescription = (property_name) => {
    const maxLength = 34; // Establece el límite de caracteres que quieres mostrar
    if (property_name.length > maxLength) {
      return property_name.substring(0, maxLength) + '...'; // Recorta y añade "..."
    }
    return property_name; // Si no es largo, muestra la descripción completa
  };
  async function confirmDelete() {
      try {
        // Configuración de los encabezados
        const options = {
          headers: {
            'Authorization': `Bearer ${session.value.token_api}`
          }
        };

        // Envío de la solicitud con el rol_id
        const data = { company_id: selectedCargoId.value };
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/company-delete`,
          data, 
          options
        );

        // Manejo de la respuesta
        if (response.status === 200) {
          showModal.value = false
          console.log("Cargo eliminado correctamente:", response.data.message);
          get_propierties();  
          return response.data.message; // Mensaje de éxito desde la API
          
        } else {
          console.error("Error en la respuesta de la API: estructura inesperada");
        }
      } catch (error) {
        console.error(
          "Error al intentar eliminar el cargo:",
          error.response?.data?.message || error.message
        );
      }
    }
    const goToCompanyForm = (advisorId) => {
    router.push({ 
      name: 'AdvisorPropertiesCreate', 
      params: { advisorId } // Envías el ID del asesor como parámetro
    });
  };
    const verPerfil = (url) => {
      // Abre la URL en una nueva pestaña
      window.open(url, '_blank');
    };
    const editCargo = (id) => {
      console.log("ID del rol:", id); // Imprime el ID en la consola
      router.push({ name: 'propertyFormEdit', params: { id } }); // Asegúrate de que el nombre coincida con el de la ruta
    };
    const filteredCargos = computed(() => {
        if (!Array.isArray(properties.value)) return [];

        let filtered = properties.value;

        // Aplicar filtro de búsqueda por nombre
        if (searchQuery.value) {
            filtered = filtered.filter(property => 
                property.property_name.toLowerCase().includes(searchQuery.value.toLowerCase())
            );
        }

        // Aplicar filtro por tipo de inmueble
        if (propertyTypeFilter.value) {
            filtered = filtered.filter(property => 
                property.type_property === propertyTypeFilter.value
            );
        }

        // Aplicar filtro por estatus
        if (statusFilter.value) {
            filtered = filtered.filter(property => 
                property.translatedStatus === statusFilter.value
            );
        }

        // Paginar los resultados
        const start = (currentPage.value - 1) * itemsPerPage.value;
        const end = start + itemsPerPage.value;

        return filtered.slice(start, end);
    });
    // Modificar el computed totalPages para considerar ambos filtros
    const totalPages = computed(() => {
        let filtered = properties.value;

        if (searchQuery.value) {
            filtered = filtered.filter(property =>
                property.property_name.toLowerCase().includes(searchQuery.value.toLowerCase())
            );
        }

        if (propertyTypeFilter.value) {
            filtered = filtered.filter(property => 
                property.type_property === propertyTypeFilter.value
            );
        }

        if (statusFilter.value) {
            filtered = filtered.filter(property =>
                property.translatedStatus === statusFilter.value
            );
        }

        return Math.ceil(filtered.length / itemsPerPage.value);
    });
    const changePage = (page) => {
      if (page >= 1 && page <= totalPages.value) {
        currentPage.value = page;
      }
    };
    // Manejo de clics fuera del menú
    const handleClickOutside = (event) => {
      // Si el clic no fue dentro de ningún contenedor de menú, cerrar el menú visible
      if (!menuContainers.value.some(container => container?.contains(event.target))) {
        menuVisible.value = null;
      }
    };

    const toggleMenu = (userId) => {
      menuVisible.value = menuVisible.value === userId ? null : userId;
    };
    
  //const showToast = (message) => {
  //successMessage.value = message;
  //setTimeout(() => {
  //  successMessage.value = ''; // Ocultar el mensaje después de 3 segundos
  //}, 3000);
  //};
  // Lifecycle hooks
  onMounted(() => {
  get_propierties();
  document.addEventListener('click', handleClickOutside);
  });

  onBeforeUnmount(() => {
      document.removeEventListener('click', handleClickOutside);
  });

 
  
  </script>
  
  <style scoped>
    .card {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border: none;
    border-radius: 8px;
    }
  </style>